import { render, staticRenderFns } from "./job-analysis.vue?vue&type=template&id=2f23a35c&scoped=true"
import script from "./job-analysis.vue?vue&type=script&lang=js"
export * from "./job-analysis.vue?vue&type=script&lang=js"
import style0 from "./job-analysis.vue?vue&type=style&index=0&id=2f23a35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23a35c",
  null
  
)

export default component.exports